<script>
import VueContentLoading from "vue-content-loading";

export default {
  components: { VueContentLoading }
};
</script>

<template>
  <div class="panel panel-default resultado">
    <vue-content-loading :width="850" :height="180">
      <rect x="0" y="0" width="210" height="180" />

      <rect x="225" y="15" rx="1" ry="1" width="390" height="20" />
      <rect x="225" y="45" rx="1" ry="1" width="215" height="15" />

      <rect x="640" y="0" width="210" height="180" />
    </vue-content-loading>
  </div>
</template>

<style lang="scss" scoped>
.resultado {
  border: 0;
  overflow: hidden;
  position: relative;
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2),
    0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12) !important;

  svg {
    display: block;
  }
  > .fa-picture-o {
    position: absolute;
    top: 55px;
    font-size: 130px;
    left: 45px;
    color: #959595;
  }
}
</style>